import { action } from 'typesafe-actions';
import * as types from './user.actionTypes';
import { UserAuth } from '@nimbly-technologies/nimbly-common';

export const setAuthenticatedProfile = (user: UserAuth) => action(types.SET_AUTHENTICATED_PROFILE, { user });
export const setUserIsSandbox = (isSandboxAccount: boolean) => action(types.SET_SANDBOX_ACCOUNT, { isSandboxAccount });
